import axios from 'axios'

const instance = axios.create({
    headers: {
        'Authorization': {
            toString() {
                return `Bearer ${localStorage.getItem('token')}`
            }
        },
        //TODO: need use in first time from userprofile from feature
        'ClientId': localStorage.getItem('ClientId') == null ? 1 : localStorage.getItem('ClientId')
    }
});

export default instance